var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideFbq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 1H3C1.89543 1 1 1.89543 1 3V71C1 72.1046 1.89543 73 3 73H77C78.1046 73 79 72.1046 79 71V3C79 1.89543 78.1046 1 77 1Z",
    fill: "#F5F8FA",
    stroke: "#0044AA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 11H17V62H63V11Z",
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1054_30",
    transform: "scale(0.0217391 0.0196078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 74,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1054_30",
    width: 46,
    height: 51,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAzCAYAAADo8TpyAAAAAXNSR0IArs4c6QAAAWhJREFUaEPtmLFKw1AYhc8VutXFN+jSxcEHcI0voHCzdtbJVXBycHATfIi0a8HBBHwGCwVxdRMHwU3NlVAQi6G5979/pDTnzuec/+Tjz4XEIOYk41cAOzERQm9phMaFjcWD8ZF4MLJIw6YSP8j2UWK0RMeYa+R2tt4vZ5LdAOZ4ubi7xF16xuKyZW/YcRKXYV3hInF1pA2BpUGSHcGY7R9h6Z5RpPni1ljnWyUZfwHY+vWET8jtkMXbWaJqVUi8Hbb1qST+n7SrWSRO4p4EuCqeoNRkJK6G0jOIxD1BqclIXA2lZxCJe4JSk5G4GkrPoO4SfwQw8KSkKfuI+1jWrBKY1aHiwBV6/fNAQOHy/vsnJrb6WVV7womHV5A6HpDbPRaX4hP4Okl8cgjnTgS0FCzuHkV6IdtxhfFtRay+VdqaqpBbV/wNcFOF7OaInjnFrX1pFv5V1BWX5Mg8Drso7FxiZnEJNUQQ/wYers8yvn5ztQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideFbq);
export default __webpack_public_path__ + "static/media/side-fbq.a53057f4b41e23005a409a8cbe69b3eb.svg";
export { ForwardRef as ReactComponent };